import { Card, Typography } from '@material-ui/core'
import * as React from 'react'
import { Progress } from '../Progress'

import './style.scss'

interface IProps {}

export const ScoreLegend: React.FC<IProps> = (props: IProps) => {
  const descriptions = ['Support', 'Nurture']
  return (
    <Card className="score-legend">
      <Typography className="title">Score Legend</Typography>
      <div className="descriptions">
        {descriptions.map(d => (
          <Typography key={d} className={`description ${d.replace(' ', '-')}`}>
            {d}
          </Typography>
        ))}
      </div>
      <Progress showAllBreakpoints={true} />
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/components/Statistic/ScoreLegend/index.tsx